import { hasConflictCode } from "./graphqlConflictCodes";
import type { ApolloError } from "@apollo/client";

const STALE_FINDING_CODES: ReadonlySet<string> = new Set(["STALE_FINDING"]);

// NOT_FOUND: no finding envelope for (arena, findingId) — the finding never
// existed here or was pruned. FINDING_WITHDRAWN: the finding's document binding
// was removed or replaced, so the finding is off every read surface. Both mean
// the target is gone underneath the reviewer: a refetch drops the row and
// retrying the same write can't succeed, so callers must not offer "try again".
const FINDING_GONE_CODES: ReadonlySet<string> = new Set(["NOT_FOUND", "FINDING_WITHDRAWN"]);

/**
 * True when `submitFindingFeedback` failed because the finding was superseded
 * by a re-run since the page loaded (`extensions.currentFindingId` carries the
 * replacement id). Checked via the typed `extensions.code`, not
 * message-substring matching — see `fayAuthErrors.ts` for the same convention.
 */
export function isStaleFindingError(error: ApolloError): boolean {
  return hasConflictCode(error, STALE_FINDING_CODES);
}

/**
 * True when `submitFindingFeedback` failed because the target finding is gone —
 * either absent (`NOT_FOUND`) or withdrawn with its document
 * (`FINDING_WITHDRAWN`). Typed via `extensions.code`, mirroring
 * `isStaleFindingError`; the caller refetches to drop the row rather than
 * inviting a retry that can never land.
 */
export function isFindingGoneError(error: ApolloError): boolean {
  return hasConflictCode(error, FINDING_GONE_CODES);
}
